import { render, staticRenderFns } from "./ProjectValuationExternalReportPage3.vue?vue&type=template&id=2cb6c2d4&"
import script from "./ProjectValuationExternalReportPage3.vue?vue&type=script&lang=ts&"
export * from "./ProjectValuationExternalReportPage3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports